import Interactive from 'modules/overlay-canvas/canvases/interactive';
import groupAlignment from './group';
import singleAlignment from './single';

export class Alignment {
  single = singleAlignment;
  group = groupAlignment;

  init(manager: Interactive) {
    this.single.init(manager);
    this.group.init(manager);
  }
}

const alignment = new Alignment();
export default alignment;
